export const BREAKPOINT_XSMALL = 425;
export const BREAKPOINT_SMALL = 550;
export const BREAKPOINT_MEDIUM = 768;
export const BREAKPOINT_LARGE = 1024;
export const BREAKPOINT_XLARGE = 1200;
export const BREAKPOINT_XLARGEALT = 1368;
export const BREAKPOINT_XXLARGE = 1440;
